import { ReactNode } from "react";

export interface IContainer {
  children: ReactNode;
  className: string;
}
function Container({ children, className }: IContainer) {
  return (
    <>
      <div className={"container " + className}>{children}</div>
    </>
  );
}

export default Container;
